export enum LanguagePreference {
  English = 'person.language.preference.english',
  Afrikaans = 'person.language.preference.afrikaans',
  Zulu = 'person.language.preference.zulu',
  Pedi = 'person.language.preference.pedi',
  Tswana = 'person.language.preference.tswana',
  Xhosa = 'person.language.preference.xhosa',
  Tsonga = 'person.language.preference.tsonga',
  Venda = 'person.language.preference.venda',
  Swati = 'person.language.preference.swati',
  Ndebele = 'person.language.preference.ndebele',
  Sotho = 'person.language.preference.sotho',
}

export const LanguagePreferenceDisplay: Record<LanguagePreference, string> = {
  [LanguagePreference.English]: 'English',
  [LanguagePreference.Afrikaans]: 'Afrikaans',
  [LanguagePreference.Zulu]: 'Zulu',
  [LanguagePreference.Pedi]: 'Pedi',
  [LanguagePreference.Tswana]: 'Tswana',
  [LanguagePreference.Xhosa]: 'Xhosa',
  [LanguagePreference.Tsonga]: 'Tsonga',
  [LanguagePreference.Venda]: 'Venda',
  [LanguagePreference.Swati]: 'Swati',
  [LanguagePreference.Ndebele]: 'Ndebele',
  [LanguagePreference.Sotho]: 'Sotho',
};
